import axios from 'lib/axios'
import { CreateReportRequest, ReportResponse } from 'models'

const basePath = '/api/v4/reports'

export const ReportServiceV4 = {
  createReport: async (request: CreateReportRequest): Promise<ReportResponse> => {
    const { data } = await axios.post(basePath, request)
    return data
  },

  getReport: async (reportId: string): Promise<ReportResponse> => {
    const { data } = await axios.get(`${basePath}/${reportId}`)
    return data
  },

  downloadReport: async (reportId: string): Promise<Blob> => {
    const { data } = await axios.get(`${basePath}/${reportId}/download`, {
      responseType: 'blob'
    })
    return data
  }
}
